import BlockContent from '@sanity/block-content-to-react'
import { styled, H2, H3Alternate, BodyLarge } from '@thesisedu/web/dist'
import React from 'react'

import { Callout } from './Callout'
import { StepImage } from './StepImage'
import { Video } from './Video'
import { PRODUCT_INFO, PRODUCT_NAME, PRODUCT_INFO_MAP } from './constants'

export function useArticleMetadata(props) {
  return {
    title: props.pageContext.name,
    description: props.pageContext.description,
  }
}

const BorderH2 = styled(H2)`
  padding-bottom: ${props => props.theme['@size-xs']};
  border-bottom: solid 1px ${props => props.theme['@border-color-base']};
  margin-bottom: ${props => props.theme['@size-l']} !important;
  &:not(:first-child) {
    margin-top: ${props => props.theme['@size-xl']} !important;
  }
`

function BlockRenderer(props) {
  const { style = 'normal' } = props.node
  if (style === 'h1') return <BorderH2 children={props.children} />
  if (style === 'h2') return <H3Alternate isBlock children={props.children} />
  if (style === 'h3')
    return <H3Alternate isBlock color={'@text-color-secondary'} children={props.children} />
  else return <BodyLarge isBlock children={props.children} />
}

function ProductName({ info, item }) {
  return <span>{info[PRODUCT_INFO_MAP[item || 'name']]}</span>
}

function ProductSpecific({ node: { product, content } }) {
  if (product === PRODUCT_NAME) {
    return <Content content={content} />
  } else {
    return null
  }
}

function ImageWithAlt({ node: { asset, alternate } }) {
  return <img src={asset.url} alt={alternate} />
}

export function Content({ content }) {
  const productInfo = PRODUCT_INFO
  return (
    <BlockContent
      blocks={content}
      imageOptions={{
        w: 800,
        h: 800,
        fit: 'max',
      }}
      serializers={{
        types: {
          block: BlockRenderer,
          'product-specific': ProductSpecific,
          callout: Callout,
          'step-image': StepImage,
          'image-with-alt': ImageWithAlt,
          video: Video,
        },
        marks: {
          productName: ({ mark: { item } }) => <ProductName info={productInfo} item={item} />,
          link: ({ children, mark: { href, blank } }) => (
            <a href={href} target={blank ? '_blank' : undefined} children={children} />
          ),
          internalLink: ({ children, mark: { reference } }) => (
            <a href={`/learn/articles/${reference.slug.current}`} children={children} />
          ),
        },
      }}
    />
  )
}

export function Article({ pageContext }) {
  return <Content content={pageContext._rawContent} />
}
